<app-company-roles-table
	[company]="company"
	[roleDataRequest]="getCompanyRolesByCompanyId"
	(roleSelected)="onRoleSelected($event)"
	style="flex: 1; display: flex; overflow: auto"
>
</app-company-roles-table>
